import Axios, { AxiosResponse } from "axios";
import {ActionCreator, AnyAction, Dispatch} from "redux";
import {ThunkAction, ThunkDispatch} from "redux-thunk";
import { UserManagementAxios } from "../Contracts/Axios/UserManagementAxios";
import { IStore } from "../Models/IStore";
import { ITerritory, IUser } from "../Models/Models";
import * as types from "./Types";
import {notification} from "antd";
import {getUserPreferences} from "./UserPreferencesActions";
import {RootState} from "../Reducers/RootReducer";

// GET
export const getUserFranchiseeStoreInformation: ActionCreator<
  ThunkAction<any, any, any, any>
> = (userID: number) => {
    return (dispatch: Dispatch): void => {
        const userFranchiseeInfoAjax = new UserManagementAxios();
        const promises = [];
        promises.push(
            userFranchiseeInfoAjax.GetUserFranchiseeStoreInformation(userID)
        );

        Axios.all(promises)
            .then(
                Axios.spread((storeInfo) => {
                    dispatch(getUserFranchiseeStoreInformationSuccess(storeInfo));
                })
            )
            .catch((error: any) => {
                dispatch(getUserFranchiseeStoreInformationFailure(error));
            });
    };
};

// GET
export const getUserFranchiseeTerritoryInformation: ActionCreator<
  ThunkAction<any, any, any, any>
> = (userID: number) => {
    return (dispatch: Dispatch): void => {
        const userFranchiseeInfoAjax = new UserManagementAxios();
        const promises = [];
        promises.push(
            userFranchiseeInfoAjax.GetUserFranchiseeTerritoryInformation(userID)
        );

        Axios.all(promises)
            .then(
                Axios.spread((territoryInfo) => {
                    dispatch(getUserFranchiseeTerritoryInformationSuccess(territoryInfo));
                })
            )
            .catch((error: any) => {
                dispatch(getUserFranchiseeTerritoryInformationFailure(error));
            });
    };
};

// UPDATE
export const removeStoreFromFranchiseeUser: ActionCreator<
  ThunkAction<any, any, any, any>
> = (userID: number, storeID: number) => {
    return (dispatch: Dispatch): void => {
        const userFranchiseeInfoAjax = new UserManagementAxios();
        const promises = [];
        promises.push(
            userFranchiseeInfoAjax.RemoveStoreFromFranchiseeUser(userID, storeID)
        );

        Axios.all(promises)
            .then(
                Axios.spread((response: AxiosResponse) => {
                    dispatch(removeStoreFromFranchiseeUserSuccess(storeID, userID));
                })
            )
            .catch((error: any) => {
                dispatch(removeStoreFromFranchiseeUserFailure(error));
            });
    };
};

// UPDATE
export const removeTerritoryFromFranchiseeUser: ActionCreator<
  ThunkAction<any, any, any, any>
> = (userID: number, territoryID: number) => {
    return (dispatch: Dispatch): void => {
        const userFranchiseeInfoAjax = new UserManagementAxios();
        const promises = [];
        promises.push(
            userFranchiseeInfoAjax.RemoveTerritoryFromFranchiseeUser(
                userID,
                territoryID
            )
        );

        Axios.all(promises)
            .then(
                Axios.spread((response: AxiosResponse) => {
                    dispatch(
                        removeTerritoryFromFranchiseeUserSuccess(territoryID, userID)
                    );
                })
            )
            .catch((error: any) => {
                dispatch(removeTerritoryFromFranchiseeUserFailure(error));
            });
    };
};

// UPDATE
export const updateUserActiveStatus: ActionCreator<
  ThunkAction<any, any, any, any>
> = (userID: number, activeStatus: boolean) => {
    return (dispatch: Dispatch): void => {
        const updateUserActiveStatusAjax = new UserManagementAxios();
        const promises = [];
        promises.push(
            updateUserActiveStatusAjax.UpdateUserActiveStatus(userID, activeStatus)
        );

        Axios.all(promises)
            .then(
                Axios.spread((updatedUser) => {
                    dispatch(updateUserActiveStatusSuccess(updatedUser));
                })
            )
            .catch((error: any) => {
                dispatch(userUpdateActiveStatusFailure(error));
            });
    };
};

//Update
export const updateSessionTimeoutLength: ActionCreator<
    ThunkAction<void, RootState, unknown, AnyAction>
> = (companyId: number, newSessionTimeoutLength: number) => {
    return (dispatch: ThunkDispatch<RootState, unknown, AnyAction>): void => {
        const userManagementAxios = new UserManagementAxios();
        const promises = [];
        const convertToHours = () => {
            if(newSessionTimeoutLength >= 60) {
                let hours = Math.floor(newSessionTimeoutLength / 60);
                let remainingMinutes = newSessionTimeoutLength % 60;
                return `${hours} hour(s) and ${remainingMinutes} minute(s).`;
            } else {
                return `${ newSessionTimeoutLength } minute(s).`;
            }
        }
        promises.push(
            userManagementAxios.UpdateSessionTimeoutLength(companyId, newSessionTimeoutLength)
        );
        Axios.all(promises)
            .then(Axios.spread((response: AxiosResponse) => {
                dispatch(updateSessionTimeoutLengthSuccess(response));
                notification.success({
                    message: "Session Timeout Length Updated",
                    description: `Session timeout length has been updated to ` + convertToHours(),
                })
                dispatch(getUserPreferences());
            })
            )
            .catch((error: any) => {
                dispatch(updateSessionTimeoutLengthFailure(error));
                notification.error({
                    message: "Session Timeout Length Update Failed",
                    description: "There was an error updating the session timeout length.",
                })
            });
        }
}

//------------------------------------------------ SUCCESS
const getUserFranchiseeStoreInformationSuccess = (data: Array<IStore>) => ({
    type: types.GET_USER_FRANCHISEE_STORE_INFORMATION_SUCCESS,
    response: data,
});
const getUserFranchiseeTerritoryInformationSuccess = (
    data: Array<ITerritory>
) => ({
    type: types.GET_USER_FRANCHISEE_TERRITORY_INFORMATION_SUCCESS,
    response: data,
});
const removeStoreFromFranchiseeUserSuccess = (
    storeID: number,
    userID: number
) => ({
    type: types.REMOVE_STORE_FROM_FRANCHISEE_USER_SUCCESS,
    response: {
        storeID,
        userID,
    },
});
const removeTerritoryFromFranchiseeUserSuccess = (
    territoryID: number,
    userID: number
) => ({
    type: types.REMOVE_TERRITORY_FROM_FRANCHISEE_USER_SUCCESS,
    response: {
        territoryID,
        userID,
    },
});
const updateUserActiveStatusSuccess = (data: IUser) => ({
    type: types.USER_UPDATE_ACTIVE_STATUS_SUCCESS,
    response: data,
});

const updateSessionTimeoutLengthSuccess = (data: AxiosResponse<any>) => ({
    type: types.UPDATE_SESSION_TIMEOUT_LENGTH_SUCCESS,
    response: data
});

//------------------------------------------------ FAILURE
const getUserFranchiseeStoreInformationFailure = (error: any) => ({
    type: types.GET_USER_FRANCHISEE_STORE_INFORMATION_FAILURE,
    response: error,
});
const getUserFranchiseeTerritoryInformationFailure = (error: any) => ({
    type: types.GET_USER_FRANCHISEE_TERRITORY_INFORMATION_FAILURE,
    response: error,
});
const removeStoreFromFranchiseeUserFailure = (error: any) => ({
    type: types.REMOVE_STORE_FROM_FRANCHISEE_USER_FAILURE,
    response: error,
});
const removeTerritoryFromFranchiseeUserFailure = (error: any) => ({
    type: types.REMOVE_TERRITORY_FROM_FRANCHISEE_USER_FAILURE,
    response: error,
});
const userUpdateActiveStatusFailure = (error: any) => ({
    type: types.USER_UPDATE_ACTIVE_STATUS_FAILURE,
    response: error,
});

const updateSessionTimeoutLengthFailure = (error: any) => ({
    type: types.UPDATE_SESSION_TIMEOUT_LENGTH_FAILURE,
    response: error
});
